import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=9f8d825a&scoped=true"
import script from "./Unsubscribe.vue?vue&type=script&lang=ts"
export * from "./Unsubscribe.vue?vue&type=script&lang=ts"
import style0 from "./Unsubscribe.vue?vue&type=style&index=0&id=9f8d825a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8d825a",
  null
  
)

export default component.exports